import { Box, Stack, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { FormAwarePercentInput } from '@/components/form/formAwareInputs/FormAwarePercentInput';
import { FormAwareSwitch } from '@/components/form/formAwareInputs/FormAwareSwitch';
import { Card } from '@/components/layout/Card/Card';
import { useFormContext } from '@/components/react-hook-form';
import { validateNumberRange } from '@/utils/validators/validateNumberRange';

import {
  FullScreenStructuredAssetsModalForm,
  FullScreenStructuredAssetsModalFormPath,
} from './FullScreenStructuredAssetsModal.types';

export function DiscountEntityCard() {
  const { control } = useFormContext<FullScreenStructuredAssetsModalForm>();

  const [showCurrentDiscountedValueOnBalanceSheet] = useWatch({
    control,
    name: ['showCurrentDiscountedValueOnBalanceSheet'],
  });

  return (
    <Card variant="filled">
      <Stack spacing={2} p={2}>
        <Typography variant="title-s" component="span">
          Valuation discount
        </Typography>
        <Stack spacing={2}>
          <FormAwareSwitch
            fieldName={
              'showCurrentDiscountedValueOnBalanceSheet' as const satisfies FullScreenStructuredAssetsModalFormPath
            }
            control={control}
            label="Apply discount for tax calculation purposes"
            labelPosition="right"
            variant="dark"
          />
          {showCurrentDiscountedValueOnBalanceSheet && (
            <Box sx={{ pl: 7 }}>
              <FormAwarePercentInput<FullScreenStructuredAssetsModalForm>
                control={control}
                fieldName={
                  `currentDiscountedValuePercentage` as const satisfies FullScreenStructuredAssetsModalFormPath
                }
                label="Discount percentage"
                isDecimalJSInput
                hideLabel
                maxValue={100}
                required
                decimalScale={2}
                validation={{
                  minMax: validateNumberRange({
                    min: 0.01,
                    max: 100,
                    fieldName: 'Discount rate',
                  }),
                }}
              />
            </Box>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}
